import { decode, encode } from "base64-arraybuffer";
import config from "@/config";
var CryptoJS = require("crypto-js");
import { DateTime } from 'luxon'

export const generateSalt = function () {
  const currentDt = DateTime.now().toUTC()
  let unixTs = currentDt.toFormat('x')
  let prefix = ''
  let a1 = unixTs.substring(11, 13)
  let a2 = parseInt(currentDt.toFormat('yy')) * 2
  let a3 = (parseInt(currentDt.toFormat('yy')) + 1) * currentDt.month
  let a4 = a2 + a3 + currentDt.day
  prefix = `${a1}${a2.toString().padStart(2, '0')}${a3.toString().padStart(3, '0')}${a4.toString().padStart(3, '0')}`

  let postfix = ''
  let b1 = (currentDt.hour * 2) + currentDt.day
  let b2 = currentDt.minute + currentDt.day
  let b3 = unixTs.substring(unixTs.length - 6)
  postfix = `${b1.toString().padStart(2, '0')}${b2.toString().padStart(2, 0)}${b3}`

  let salt = `${prefix}-${config.tokenKey}-${postfix}`
  return salt
}

export const getSalt = function () {
  return generateSalt()
}

export const Decrypt = function (cipherText) {
  let key = CryptoJS.enc.Utf8.parse(config.tokenKey);
  var iv = CryptoJS.enc.Utf8.parse(config.ivKey);
  let decryptedBytes = CryptoJS.AES.decrypt(
    decodeURIComponent(cipherText),
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  let decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

  if (decryptedText) {
    let decrypted = JSON.parse(decryptedText);
    if (typeof decrypted !== "object") {
      return decrypted;
    }
    return toCamel(decrypted);
  }
  return null;
};

export const Encrypt = function (obj) {
  let data = {
    ...obj,
    ckTime: +new Date()
  }

  let key = CryptoJS.enc.Utf8.parse(config.tokenKey);
  var iv = CryptoJS.enc.Utf8.parse(config.ivKey);
  let encryptedBytes = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let encryptedString = encryptedBytes.toString();
  return encryptedString;
};

export const decodeAuth = function (x) {
  let str = decode(x);
  return JSON.parse(new TextDecoder().decode(str));
};

export const strDecodeAuth = function (x) {
  let str = decode(x);
  return new TextDecoder().decode(str);
};

export const encodeAuth = function (x) {
  let str = encode(stringArrayBuffer(x));
  return str;
};

function stringArrayBuffer(str) {
  const buffer = new ArrayBuffer(str.length);
  const bytes = new Uint8Array(buffer);

  str.split("").forEach(function (str, i) {
    bytes[i] = str.charCodeAt(0);
  });

  return buffer;
}

function toCamel(o) {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (
          origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}

export default { decodeAuth, encodeAuth, strDecodeAuth, Decrypt, Encrypt }
